export enum LocalMenuGroupRoutePathNames {
  LOCAL_MENUS = 'local-menus',
  BRAND_DETAILS = 'brand',
  LIST = '',
  ID = ':id',
  BRAND_ID = ':brandId',
  MENUS = 'menus',
  MENU_ID = ':menuId',
  CATEGORY = 'category',
  CATEGORY_ID = ':categoryId',
  ITEMS = 'items',
  MOD_GROUP = 'modifier-group',
  MOD_GROUP_ID = ':modifierGroupId?',
  MODIFIERS = 'modifiers',
  INSIGHTS = 'insights',
  UPDATES = 'updates',
  ACTIVITY_LOG = 'activity-log',
  MENUWORKS = 'menuworks',
  MENUWORKS_UNIT_ID = ':unitId?',
  ENTITY = ':entity',
  ENTITY_ID = ':entityId?',
  MODE = ':mode?',
}
